<template>
  <div id="myProgress" style="border:1px solid #dddddd">
    <div id="myBar" :class="{'bar': true, 'progressdisable': this.data.result !== -1 && this.data.result !== 0}" :style="{'width': width}">
        <div id="label" class="barlabel" v-html=width style='color: #ccc'></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress',
  data() {
    return {
       data: {}, 
    };
  },
  computed: {
    width: function () {
        // if (this.data.progress <= 20) {
        //     this.data.progress += 20;
        // }
        return this.data.progress + '%';
    }
  }
};
</script>

<style scoped>
#myProgress {
    position: relative;
    height: 18px;
    width: 15em;
    text-align: left;
    background-color: white;
}

.highcontrast #overviewgrid #myProgress {
    background-color: black;
}

#myBar {
    position: absolute;
    width: 15%;
    height: 100%;
    background-color: #007bff;
}

#myBar.progressdisable {
    background-color: #df2222;
}

#label {
    position: relative;
    left: 10px;
    line-height: 18px;
    font-size: 10px;
    color: white;
}
</style>>